import React from 'react';
import { formatNZD, interpolateText } from '@sparknz/journeys-common';
import { Text } from '@sparknz/spark-pattern-library';
import { ImpressionRegion } from '@sparknz/tracking';

import { removePrices } from 'components/shop/MobilePlans/utils/removePrices.utils';

interface AddCompanionsDescriptionProps {
  title: string;
  template: string;
  variables: DescriptionTemplateVariables;
}

interface DescriptionTemplateVariables {
  leaderPlanName: string | null;
  companionPlanName: string | null;
  companionPlanPrice: number;
}

const getImpressionData = (title: string, message: string) => ({
  event: [
    {
      eventInfo: {
        eventName: 'Component View',
        eventAction: 'component.view',
      },
    },
  ],
  component: [
    {
      componentInfo: {
        componentID: 'add.companionPlan',
        componentName: 'Add Companion Plan Message',
      },
      category: {
        primaryCategory: 'ServicePlan',
      },
      attributes: {
        content: {
          title,
          message,
        },
      },
    },
  ],
});

const AddCompanionsDescription = ({
  title,
  template,
  variables: { leaderPlanName, companionPlanName, companionPlanPrice },
}: AddCompanionsDescriptionProps) => {
  const description = interpolateText(template, {
    leaderPlanName: leaderPlanName ? removePrices(leaderPlanName) : '',
    companionPlanName: companionPlanName ? removePrices(companionPlanName) : '',
    companionPlanPrice: formatNZD(companionPlanPrice, 0),
  });

  return (
    <ImpressionRegion impressionData={getImpressionData(title, description)}>
      <Text variant="bodySMedium" mb="s5">
        {description}
      </Text>
    </ImpressionRegion>
  );
};

export default AddCompanionsDescription;
